import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconExpandSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"expand-simple"} maskId="square-filled-radius-0-stroke-1-IconExpandSimple"><path fillRule="evenodd" clipRule="evenodd" d="M12 5H19V12H18V6H12V5ZM6 12V18H12V19H5V12H6Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconExpandSimple;
